import { number } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateStructure, CollapseValueCell } from "@tools";
import { Grid } from "@material-ui/core";
import useStyle from "../../TimelineSectionsRow/components/SectionCell.style";
import useCellStyle from "@tools/EstimateEditor/styles/CommonTableCellStyles.style";
import classnames from "classnames";

export const TimelineSectionTitleCell = observer(({ monthIndex }) => {
  
  const classes = useStyle();
  const cellClasses = useCellStyle();
  const structure = useEstimateStructure();
  
  const isOpened = structure.settings.expandedMonthList.includes(monthIndex+1);
  // const isOpened = useMemo(() => (
  //   structure.settings.isTimelineMonthExpanded(monthIndex)
  // ), [structure.settings.expandedTimelineMonths?.size]);
  
  return (
    <CollapseValueCell
      isOpened={isOpened}
      narrowChildren
      useBorder
      isHeader
      visible
      isFirst={monthIndex === 0}
    >
      {
        isOpened &&
        [...new Array(4).keys()]
          .map((week) => (
            <Grid
              key={`week${week}`}
              item container
              alignItems="center"
              className={classnames(
                "h-full",
                cellClasses.fullDashBorderRight,
                classes.weekCell
              )}
            />
          ))
      }
    </CollapseValueCell>
  );
});

TimelineSectionTitleCell.propTypes = {
  monthIndex: number
};